export function getCategories() {
  const categories = {
    bygg: {
      id: "bygg",
      label: "Bygg",
      subCategories: [
        "Betongare",
        "Golvläggare",
        "Grovarbetare",
        "Håltagare",
        "Murare",
        "Plattsättare",
        "Snickare",
        "Takläggare",
      ],
    },
    el: {
      id: "el",
      label: "El",
      subCategories: [
        "Automation",
        "Elektriker",
        "Fiber & Data",
        "Hiss",
        "Larm",
      ],
    },
    entreprenad: {
      id: "entreprenad",
      label: "Entreprenad",
      subCategories: [
        "Mark & Anläggning",
        "Maskinförare",
        "Ställningsbyggare",
        "Transport",
      ],
    },
    maleri: {
      id: "maleri",
      label: "Måleri",
      subCategories: [],
    },
    vvs: {
      id: "vvs",
      label: "VVS",
      subCategories: [
        "Isoleringsmontör",
        "Kyltekniker",
        "Sprinklermontör",
        "Ventilationsmontör",
        "VVS montör",
      ],
    },
    ovrigt: {
      id: "ovrigt",
      label: "Övrigt",
      subCategories: [
        "Konsulter",
        "Fastighetsskötare",
        "Glasmästare",
        "Plåt",
        "Smed & Lås",
        "Övrigt",
      ],
    },
  };
  return categories;
}

export function getCategoryById(categoryId) {
  return getCategories()[categoryId];
}
